
export interface AlertMessage {
  message: string;
  translated: boolean;
  params?: any;
}
